import React, { useState } from "react";
import {
  Button,
  LinearProgress,
  TableRow,
  TableCell,
  Table,
  TableBody,
  useMediaQuery,
  TextField,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  callGroupRegistrationApi,
  getGroupRegistrationProgress,
} from "./services";
import { useSnackbar } from "notistack";
import DownloadFileLink from "../../components/DownloadFile/DownloadFileLink";
import ExcelFile from "../../resources/GroupRegistrationTemplate.xlsx";

// Zustand store
import { useAppStore } from "../../stores";

import _ from "lodash";
import MUIDataTableWrapper from "../../components/MUIDataTableWrapper/MUIDataTableWrapper";

interface Props { }

//actions
const GroupRegistration: React.FC<Props> = () => {
  // Zustand store
  const registrantResults = useAppStore(
    (state) => state.groupRegistration?.registrantResults || []
  );
  const setFileLoading = useAppStore((state) => state.setFileLoading);
  const setFileLoaded = useAppStore((state) => state.setFileLoaded);
  const setGroupRegistrationPending = useAppStore((state) => state.setGroupRegistrationPending);
  const setGroupRegistrationSuccessful = useAppStore((state) => state.setGroupRegistrationSuccessful);
  const setRegistrantResults = useAppStore((state) => state.setRegistrantResults);

  const { enqueueSnackbar } = useSnackbar();
  const displayMobile = useMediaQuery("(max-width:959px)");

  const [uploadFile, setUploadFile] = useState<any>([]);
  const [uploadFilename, setUploadFilename] = useState("No File");
  const [downloadText] = useState("Download Excel Template");
  const [] = useState("../../resources/GroupRegistrationTemplate.xlsx");
  const [threadResponseData, setThreadResponseData] = useState<any>({});

  const [isRegistrationPendingLocal, setIsRegistrationPendingLocal] = useState(
    false
  );
  const [isRegistrationSuccessLocal, setIsRegistrationSuccessLocal] = useState(
    false
  );
  // State for president's name and email
  const [presidentSignature, setPresidentSignature] = useState('');
  const [presidentFirstName, setPresidenFirsttName] = useState('');
  const [presidentLastName, setPresidenLastName] = useState('');
  const [presidentEmail, setPresidentEmail] = useState('');

  const IsFormClarified = presidentSignature.trim() !== ''
    && presidentFirstName.trim() !== ''
    && presidentLastName.trim() !== ''
    && presidentEmail.trim() !== '';

  const IsSubmitReady = !(uploadFile.length <= 0);

  const handlePresidentSignatureChange = (event: any) => {
    setPresidentSignature(event.target.value);
  };

  const handlePresidentFirstNameChange = (event: any) => {
    setPresidenFirsttName(event.target.value);
  };

  const handlePresidentLastNameChange = (event: any) => {
    setPresidenLastName(event.target.value);
  };

  const handlePresidentEmailChange = (event: any) => {
    setPresidentEmail(event.target.value);
  };

  React.useEffect(() => {
    if (!_.isEmpty(threadResponseData)) {
      checkForUpdates(threadResponseData);
    }
  }, [threadResponseData]);

  const onChange = (e: any) => {
    if (e.target.files.length) {
      let file = e.target.files[0];
      setFileLoading(file.name);
      setUploadFile(file);
      setFileLoaded(file.name);
      setUploadFilename(file.name);
    }
  };

  const onSubmit = (e: any) => {
    e.preventDefault();

    console.log('President Name:', presidentFirstName + presidentLastName);

    console.log('President Email:', presidentEmail);

    let formData = new FormData();
    formData.append("file", uploadFile);
    submitGroupRegistration(formData);
  };

  var trapFlag = false;
  const checkForUpdates = (threadResponse: any) => {
    if (
      threadResponse.rowCount != threadResponse.currentRow &&
      threadResponse.threadMessages.length < 1
    ) {
      setTimeout(function () {
        getGroupRegistrationProgress(threadResponse.key).then(
          (response) => {
            if (response.data) {
              setThreadResponseData(response.data.result);
              trapFlag = false;
            }
          },
          (error) => {
            if (
              error.message ==
              "Cannot read property 'percentage' of undefined" &&
              trapFlag === false
            ) {
              trapFlag = true;
              checkForUpdates(threadResponseData);
            } else {
              enqueueSnackbar(`The progress reporting service has stopped. Your list is still being uploaded and processed. Please contact AFT for support.`, {
                variant: "warning",
                persist: true,
              });
              setIsRegistrationPendingLocal(false);
              threadResponse.currentRow = -1;
            }
          }
        );
      }, 3000);
    } else {
      setRegistrantResults(threadResponse.registrantResultList);
      if (threadResponse.threadMessages.length > 0) {
        _.forEach(threadResponse.threadMessages.length, function (value) {
          enqueueSnackbar(`Error: ` + value, {
            variant: "error",
            persist: true,
          });
        });
      }
      enqueueSnackbar(`Completed: ` + threadResponse.rowCount + " entries.", {
        variant: "success",
        persist: true,
      });
      setTimeout(function () {
        setGroupRegistrationSuccessful();
        setIsRegistrationPendingLocal(false);
        setIsRegistrationSuccessLocal(true);
      }, 1000);
    }
  };

  const submitGroupRegistration = (formData: FormData) => {
    threadResponseData.currentRow = 0;
    setGroupRegistrationPending();
    setIsRegistrationPendingLocal(true);
    setIsRegistrationSuccessLocal(false);
    callGroupRegistrationApi(formData)
      .then(function (response) {
        if (response.data) {
          enqueueSnackbar(`Processing...`, {
            variant: "success",
          });
          setThreadResponseData(response.data.result);
        }
      })
      .catch((error: any) => {
        enqueueSnackbar(
          "An error has occurred.", //+ error.response.data.messages,
          {
            variant: "error",
            persist: true,
          }
        );
        setIsRegistrationPendingLocal(false);
      });
  };

  return !isRegistrationPendingLocal ? (
    <Grid container size={{ xs: 12 }}>
      <form onSubmit={onSubmit} method="post" encType="multipart/form-data">
        <Grid size={{ xs: 12 }} style={{ marginBottom: "0.5em" }}>
          <h2>Upload a List</h2>
        </Grid>
        <Grid size={{ md: 12 }} className="gr-instructions">
          Please upload file for group registration below.
          <br />
          <br />
          <b>Instructions</b>
          <br />
          1. Download the template file below. Do not rename, remove, or reformat columns in the template.
          <br />
          2. Enter the attendee's information. Columns with a <b>bold</b> title are required. Alternate Priority is required for Alternates.
          <br />
          3. <b  style={{"color": "black"}}>Ensure that each email address is unique.</b>
          <br />
          <b style={{"color": "black"}}> ** The system requires a valid and unique email address for each person.</b>
          <br />

          4. Save the file. Click "Upload File" below and select your file.
          <br />
          5. Click "Submit" below.
        </Grid>
        <Grid className="dl-template">
          <DownloadFileLink text={downloadText} filepath={ExcelFile} />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Button
            className={"browse-btn"}
            variant="contained"
            component="label"
          >
            <span>Upload File</span>
            <input
              onChange={onChange}
              type="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{ display: "none" }}
            />
          </Button>
        </Grid>

        <Grid size={{ md: 12 }} className="mb-4">
          <Grid className={"fileName"}>
            <span>File: {uploadFilename}</span>
          </Grid>
        </Grid>
        <br/>

      <Grid size={{ xs: 12, md: 3 }}>
          <Button
            className={"btn"}
            fullWidth={true}
            variant="contained"
            type="submit"
            disabled={!IsSubmitReady}
          >
            Submit
          </Button>
        </Grid>
      </form>
      {isRegistrationSuccessLocal && registrantResults.length > 0 && (
        <Grid size={{ md: 12 }} style={{ paddingTop: "3rem" }}>
          <h2>Results</h2>
          <Grid size={{ xs: 12, md: 12 }} className="pb-3">
            Please confirm your results. This has also been e-mailed to you.
          </Grid>
          <MUIDataTableWrapper
            title={"Group Registration Results"}
            columns={[
              { label: "Member Number", name: "memberNumber" },
              { label: "Name", name: "name" },
              {
                label: "Row Result",
                name: "registrantMesssage",
                options: {
                  display: displayMobile ? "false" : "true",
                },
              },
            ]}
            setExpandableRowContent={(rowData: any) => {
              return (
                <TableRow>
                  <TableCell />
                  <TableCell colSpan={3}>
                    <Table>
                      <TableBody className="inner-tbody-expandable-row">
                        <TableRow>
                          <TableCell align="left" className="tbl-col-container">
                            <div className="tbl-col-title">Row Result</div>
                            <div>
                              {rowData[2] ? rowData[2].toString() : "N/A"}
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableCell>
                </TableRow>
              );
            }}
            data={registrantResults.map((registrant: any) => {
              return {
                memberNumber: registrant.memberNumber,
                name: registrant.firstName + " " + registrant.lastName,
                registrantMesssage: registrant.message,
              };
            })}
            options={{
              print: false,
              download: true,
              viewColumns: false,
              filter: false,
              rowsPerPageOptions: [5, 10, 15, 25],
              selectableRows: "none",
            }}
          />
        </Grid>
      )}
      {isRegistrationSuccessLocal && registrantResults.length <= 0 && (
        <Grid size={{ md: 12 }} style={{ paddingTop: "1rem" }}>
          <h2>No Registrants</h2>
        </Grid>
      )}
    </Grid>
  ) : (
      <Grid container size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={threadResponseData.percentage}

          />
        </Grid>

        {threadResponseData.currentRow > 0 ? (
          <Grid size={{ xs: 12 }}>
            <span>
              Please Wait - {threadResponseData.currentRow} of{" "}
              {threadResponseData.rowCount} Processed
          </span>
          </Grid>
        ) : (
            <Grid size={{ xs: 12 }}>
              <span>Please Wait - Initializing</span>
            </Grid>
          )
        }
      </Grid>
    );
};

export default GroupRegistration;
